
<kendo-textbox (valueChange)="filterTerm = $event" [clearButton]="true" placeholder="Filter...">
  <ng-template kendoTextBoxPrefixTemplate>
    <span class="k-input-icon k-font-icon k-icon k-i-search"></span>
  </ng-template>
</kendo-textbox>

<ng-content select="[embeddedContent]"></ng-content>

<kendo-treeview #treeView  kendoTreeViewHierarchyBinding  kendoTreeViewExpandable [nodes]="data"
  [childrenField]="childrenField" [textField]="textField" [hasChildren]="hasChildren"
  [children]="fetchChildren" kendoTreeViewSelectable  [selectBy]="selectBy" [(selectedKeys)]="selectedKeys" [filter]="filterTerm"
  (selectionChange)="onSelectionChange($event)" (focus)="onFocus()" (blur)="onBlur()" (collapse)="onCollapse($event)"
  (filterChange)="onFilterChange($event)" (filterStateChange)="onFilterStateChange($event)">
</kendo-treeview>